export const objectToArray = <T>(object: { [key: string]: T }): Array<T> => {
	return Object.values(object);
};